
import React from 'react';
import {Helmet} from 'react-helmet';
import RouteStatus from '../../components/route-status.jsx';





class NotFoundPage extends React.Component {
  render() {

    return (
      <RouteStatus code={404}>
        <section className="container">
          <Helmet>
            <title>Page not found</title>
          </Helmet>
          <div className="404-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
            <h1 className="display-4">Page not found</h1>
          </div>
          <p>We couldn’t find the page you requested.</p>
        </section>
      </RouteStatus>
    );
  }
}


export default NotFoundPage;



// WEBPACK FOOTER //
// ./client/pages/main/not-found.jsx